export default "__VITE_ASSET__CDGvzvmC__$_?nuxt_component=async&nuxt_component_name=Svgo头等舱&nuxt_component_export=default__"